<template>
  <v-container id="scroll-target" fluid class="px-1 overflow-y-auto overflow-x-hidden" :style="maxHeight">
    <v-fab-transition>
      <mf-button v-if="toTopButton && scrollType !== 'box'" color="cinza-0" type="icon" icon="expand_less" class="button-fixed" @click="scrollToTop" />
    </v-fab-transition>
    <div v-scroll:#scroll-target="onScroll">
      <slot></slot>
    </div>
    <v-slide-x-transition>
      <v-row justify="center" style="height: 50px">
        <v-progress-circular v-if="loadingData" indeterminate color="primary"></v-progress-circular>
      </v-row>
    </v-slide-x-transition>
  </v-container>
</template>

<script>
export default {
  name: 'InfiniteScroll',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    percentualUpdate: {
      type: Number,
      default: 99,
    },
    height: {
      type: String,
      default: '100%',
    },
    // scrollType: box or screen
    scrollType: {
      type: String,
      default: 'screen',
      validator: (value) => ['box', 'screen'].indexOf(value) !== -1,
    },
  },
  data: () => ({
    toTopButton: false,
    timeout: null,
  }),
  computed: {
    maxHeight() {
      return `max-height: ${this.height}`
    },
    loadingData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    window.onscroll = () => {
      const {
        documentElement: { scrollTop, offsetHeight, scrollHeight },
      } = document

      const scrolledPercentual = ((scrollTop + offsetHeight) * 100) / scrollHeight

      this.showButton(scrolledPercentual)

      if (scrolledPercentual >= this.percentualUpdate) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$emit('update-data')
        }, 2000)
      }
    }
  },
  methods: {
    onScroll(e) {
      const { scrollTop, offsetHeight, scrollHeight } = e.target
      const scrolledPercentual = ((scrollTop + offsetHeight) * 100) / scrollHeight

      if (scrolledPercentual >= this.percentualUpdate) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$emit('update-data')
        }, 750)
      }
    },
    scrollToTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    showButton(scrolledPercentual) {
      const {
        documentElement: { offsetHeight, scrollHeight },
      } = document
      const startScroll = (offsetHeight * 100) / scrollHeight
      const multiplicationNumber = startScroll * 2 > 60 ? 1.5 : 2
      const percentualShowButton = startScroll * multiplicationNumber

      if (scrolledPercentual >= percentualShowButton) {
        this.toTopButton = true
        return
      }
      this.toTopButton = false
    },
  },
}
</script>

<style>
html {
  scroll-behavior: smooth;
}
.button-fixed {
  position: fixed;
  bottom: 10px;
}
</style>
